/**
 * Utility functions for GOR (Gauge of Rail) calculations and validations
 */

import { GOR_RANGE } from './constants';

/**
 * Checks if a GOR value is in the special range
 * @param gorValue - The distance from G.O.R. value
 * @returns true if the value is in the special range (0 to -28.25 inclusive)
 */
export const isInSpecialGorRange = (gorValue: number | null): boolean => {
  if (gorValue === null) return false;
  return gorValue <= GOR_RANGE.SPECIAL_MAX && gorValue >= GOR_RANGE.SPECIAL_MIN;
};

/**
 * Checks if a GOR value is exactly -28.25 (requires special ballasted track handling)
 * @param gorValue - The distance from G.O.R. value
 * @returns true if the value is exactly -28.25
 */
export const requiresBallastedTrackHandling = (gorValue: number | null): boolean => {
  return gorValue === -28.25;
};

/**
 * Calculates adjustments for special GOR cases
 * @param isBallasted - Whether the track is ballasted
 * @param hasVerticalCurve - Whether there is a vertical curve
 * @returns The total adjustment in inches
 */
export const calculateSpecialGorAdjustments = (
  isBallasted: boolean | null,
  hasVerticalCurve: boolean | null
): number => {
  let adjustments = 0;
  
  // Add 3.25 inches for ballasted track
  if (isBallasted === true) {
    adjustments += 3.25;
  }
  
  // Add 1.75 inches for vertical curvature
  if (hasVerticalCurve === true) {
    adjustments += 1.75;
  }
  
  return adjustments;
};
